export default __webpack_public_path__ + "static/media/mag9.4d4bdb4a.png";